import { useState } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { getCompetitionsRetrieveQueryOptions, attachmentsRetrieve } from "@/api/generated/backendAPI";
import { createFileRoute } from "@tanstack/react-router";
import {
  FaFile,
  FaFileCsv,
  FaFileArchive,
  FaDownload,
} from "react-icons/fa";
import { ClipLoader } from "react-spinners";


export const Route = createFileRoute("/_layout/_auth/competitions/$licenseId/data")({
  loader: ({ context: { queryClient }, params }) => {
    return queryClient.ensureQueryData(
      getCompetitionsRetrieveQueryOptions(params.licenseId)
    );
  },
  component: CompetitionData,
});

function CompetitionData() {
  const { licenseId } = Route.useParams();
  const [waiting, setWaiting] = useState(false)
  const { data: competitionData } = useSuspenseQuery(
    getCompetitionsRetrieveQueryOptions(licenseId)
  );

  const handleDataDownload = (attachment_id = "", file_name = "sampleData") => {
    setWaiting(true)
    attachmentsRetrieve(attachment_id)
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = file_name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .finally(() => {
        setWaiting(false)
      });
  };
  return (
    <>
      <h2 className="mt-4">関連データダウンロード</h2>
      <p>{competitionData.licensedCompetition.attachmentNote}</p>
      <div className="my-8">
        <ul className="flex flex-col gap-8">
          {competitionData.attachments.map((attachment) => {
            return (
              <li key={attachment.id} className="flex items-center justify-evenly gap-4 w-full">
                <div className="">
                  {
                    attachment.extension === "zip" ?
                    <FaFileArchive />
                    : attachment.extension === "csv" ?
                    <FaFileCsv />
                    : <FaFile />
                  }
                </div>
                <div className="w-2/5">
                  <h3 className="font-bold">{attachment.name}</h3>
                  <p className="text-sm">
                    {attachment.description}
                  </p>
                </div>
                <div className="w-1/5 text-sm flex flex-col justify-start gap-1">
                  <p>ファイル形式： {attachment.extension}</p>
                  {
                  //<p>データ容量：  MB</p>
                  }
                </div>
                <div className="w-1/5">
                  <button
                    onClick={() => {handleDataDownload(attachment.id, attachment.fileName)}}
                    className="flex gap-2 items-center justify-center bg-maincolor font-bold text-white text-sm"
                  >
                    <FaDownload color="white" />
                    ダウンロード
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      {waiting && (
        <div className="fixed inset-0 flex justify-center items-center bg-white bg-opacity-75 z-10">
        <ClipLoader color="#4A90E2" size={50} />
      </div>
      )}
    </>
  );
}
